import React from 'react';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
import { SectionItemEventDetails } from '../SectionItemEventDetails';
import { isEventDetailsEnabled } from '../../utils/IsEventDetailsEnabled';
function EventElement({ value, highlights, position }) {
    var _a, _b, _c, _d, _e;
    const sport = ((_a = value.sport) === null || _a === void 0 ? void 0 : _a.slug) || 'event';
    const href = `${sport}/${encodeURIComponent(value.id)}/${value.slug}`;
    const searchSection = 'Events';
    const inPlay = value.isInPlay;
    return (React.createElement(SectionItem, { expectedTitle: 2, expectedDescription: 1, cutDescription: 2, internalLink: true, href: href, id: value.id, searchSection: searchSection, position: position, inPlay: inPlay },
        React.createElement(SectionItemEventDetails, { competitionName: (_b = value.competition) === null || _b === void 0 ? void 0 : _b.name, sportId: (_c = value.sport) === null || _c === void 0 ? void 0 : _c.id, startDateTime: value.startTime }),
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.name, content: value.name })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            !isEventDetailsEnabled && (React.createElement(React.Fragment, null,
                React.createElement(Highlight, { highlighted: highlights['competition.name'], content: (_d = value.competition) === null || _d === void 0 ? void 0 : _d.name }),
                ' | ')),
            React.createElement(Highlight, { highlighted: highlights['sport.name'], content: (_e = value.sport) === null || _e === void 0 ? void 0 : _e.name }))));
}
export const EventSection = createListSection(EventElement, {
    title: 'sectionEventsTitle',
});
//# sourceMappingURL=EventSection.js.map